export default __webpack_public_path__ + "static/media/image26.f536eab2.jpg";